import * as types from '../mutation-types'
import { isArray } from '../../plugins/helper'

const addDataForRequest = (currentRequest, additionalData) => {
  if (currentRequest.hasOwnProperty('data') && isArray(currentRequest.data) && currentRequest.data.length > 0) {
    if (additionalData.hasOwnProperty('tableRelationType') && additionalData.hasOwnProperty('data')) {
      currentRequest.data[0][additionalData.tableRelationType] = additionalData.data
    }
  }

  return currentRequest
}

// State
export const state = {
  request: null,
  message: null,
  alternativeUrl: null,
}

// Mutations
export const mutations = {
  [types.CAPTURE_CURRENT_RECORD_DATA] (state, { request, message, alternativeUrl }) {
    state.request = request
    state.message = message
    state.alternativeUrl = alternativeUrl
  },

  [types.CAPTURE_ADDITIONAL_RECORD_DATA] (state, payload) {
    state.request = addDataForRequest(state.request, payload)
  },

  [types.CLEAN_CAPTURED_RECORD_DATA] (state) {
    state.request = null
    state.message = null
    state.alternativeUrl = null
  },
}

// Actions
export const actions = {
  captureRecordData ({ commit }, payload) {
    commit(types.CLEAN_CAPTURED_RECORD_DATA)
    commit(types.CAPTURE_CURRENT_RECORD_DATA, payload)
  },

  captureAdditionalRecordData ({ commit }, payload) {
    commit(types.CAPTURE_ADDITIONAL_RECORD_DATA, payload)
  },
}

// Getters
export const getters = {
  requestToRevert: state => state.request,
  messageToRevert: state => state.message,
  alternativeUrlToRevert: state => state.alternativeUrl,
}
